<script>

// 定义全局变量
const bei_ing = 'bg_imgd.png';
const logo_name = '天津市南开区建安职业培训学校';
const imgSrc = require('../../assets/img/jin_bg.png');
const payState = [{
  icon: require('@/assets/img/jin_7.png'),
  payname: '微信支付',
  is_pay: true,
  pay_id: 'wechat',
}, {
  icon: require('@/assets/img/jin_8.png'),
  payname: '支付宝',
  is_pay: false,
  pay_id: 'alipay',
}]
const riseType = [{
  icon: require('@/assets/img/jin_5.png'),
  icon: require('@/assets/img/jin_4.png'),
  icon_name: '增值税纸质普通发票'

}, {
  icon: require('@/assets/img/jin_5.png'),
  icon: require('@/assets/img/jin_4.png'),
  icon_name: '增值税专用发票'
}]
const unit = [{
  icon: require('@/assets/img/jin_5.png'),
  icon: require('@/assets/img/jin_4.png'),
  icon_name: '个人'

}, {
  icon: require('@/assets/img/jin_5.png'),
  icon: require('@/assets/img/jin_4.png'),
  icon_name: '企业'
}]
const baseUlr = 'http://ht.tjjianan.com'


export default {
  bei_ing,   //背景图片
  imgSrc,
  logo_name,
  payState,
  riseType,
  unit,
  baseUlr
}
</script>